import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { type PropsWithChildren, useEffect } from 'react';
import { lazySetLanguage, type LocaleType } from '@/utils/locale';
import { useCurrentLocale } from '@/hooks/bridge';

export interface LocaleProviderProps extends PropsWithChildren {
  locale?: LocaleType;
}

export function LocaleProvider({ children, locale: propLocale }: LocaleProviderProps) {
  const bridgeLocale = useCurrentLocale();

  // Use prop locale if provided (for component islands), otherwise fall back to bridge
  const locale = propLocale ?? bridgeLocale;

  useEffect(() => {
    lazySetLanguage(locale).catch((err: unknown) => {
      console.error(err);
    });
  }, [locale]);

  return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
}
